const { createAction } = require('../helpers')

const {
  GET_HOSPITAL_LIST,
  GET_HOSPITAL_LIST_SUCCESS,
  GET_HOSPITAL_LIST_ERROR,
  GET_HOSPITAL_LIST_RESET,

  GET_HOSPITAL,
  GET_HOSPITAL_SUCCESS,
  GET_HOSPITAL_ERROR,
  GET_HOSPITAL_RESET,

  CREATE_HOSPITAL,
  CREATE_HOSPITAL_SUCCESS,
  CREATE_HOSPITAL_ERROR,
  CREATE_HOSPITAL_RESET,

  UPDATE_HOSPITAL,
  UPDATE_HOSPITAL_SUCCESS,
  UPDATE_HOSPITAL_ERROR,
  UPDATE_HOSPITAL_RESET,

  UPDATE_HOSPITAL_STATUS,
  UPDATE_HOSPITAL_STATUS_SUCCESS,
  UPDATE_HOSPITAL_STATUS_ERROR,
  UPDATE_HOSPITAL_STATUS_RESET,

  DELETE_HOSPITAL,
  DELETE_HOSPITAL_SUCCESS,
  DELETE_HOSPITAL_ERROR,
  DELETE_HOSPITAL_RESET,
} = require('./constants')

const getHospitalList = ({ type, search, take, skip }) => createAction(GET_HOSPITAL_LIST, { type, search, take, skip })
const getHospitalListSuccess = data => createAction(GET_HOSPITAL_LIST_SUCCESS, { data })
const getHospitalListError = error => createAction(GET_HOSPITAL_LIST_ERROR, { error })
const getHospitalListReset = () => createAction(GET_HOSPITAL_LIST_RESET)

const getHospital = id => createAction(GET_HOSPITAL, { id })
const getHospitalSuccess = data => createAction(GET_HOSPITAL_SUCCESS, { data })
const getHospitalError = error => createAction(GET_HOSPITAL_ERROR, { error })
const getHospitalReset = () => createAction(GET_HOSPITAL_RESET)

const createHospital = hospital => createAction(CREATE_HOSPITAL, { hospital })
const createHospitalSuccess = data => createAction(CREATE_HOSPITAL_SUCCESS, { data })
const createHospitalError = error => createAction(CREATE_HOSPITAL_ERROR, { error })
const createHospitalReset = () => createAction(CREATE_HOSPITAL_RESET)

const updateHospital = ({ id, hospital }) => createAction(UPDATE_HOSPITAL, { id, hospital })
const updateHospitalSuccess = data => createAction(UPDATE_HOSPITAL_SUCCESS, { data })
const updateHospitalError = error => createAction(UPDATE_HOSPITAL_ERROR, { error })
const updateHospitalReset = () => createAction(UPDATE_HOSPITAL_RESET)

const updateHospitalStatus = ({ id, statusData }) => createAction(UPDATE_HOSPITAL_STATUS, { id, statusData })
const updateHospitalStatusSuccess = data => createAction(UPDATE_HOSPITAL_STATUS_SUCCESS, { data })
const updateHospitalStatusError = error => createAction(UPDATE_HOSPITAL_STATUS_ERROR, { error })
const updateHospitalStatusReset = () => createAction(UPDATE_HOSPITAL_STATUS_RESET)

const deleteHospital = ({ id }) => createAction(DELETE_HOSPITAL, { id })
const deleteHospitalSuccess = data => createAction(DELETE_HOSPITAL_SUCCESS, { data })
const deleteHospitalError = error => createAction(DELETE_HOSPITAL_ERROR, { error })
const deleteHospitalReset = () => createAction(DELETE_HOSPITAL_RESET)

module.exports = {
  getHospitalList,
  getHospitalListSuccess,
  getHospitalListError,
  getHospitalListReset,
  getHospital,
  getHospitalSuccess,
  getHospitalError,
  getHospitalReset,
  createHospital,
  createHospitalSuccess,
  createHospitalError,
  createHospitalReset,
  updateHospital,
  updateHospitalSuccess,
  updateHospitalError,
  updateHospitalReset,
  updateHospitalStatus,
  updateHospitalStatusSuccess,
  updateHospitalStatusError,
  updateHospitalStatusReset,
  deleteHospital,
  deleteHospitalSuccess,
  deleteHospitalError,
  deleteHospitalReset,
}
